module.exports = __webpack_public_path__ + "ba21461afacd00fcab1c4c562ff4e04d.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-28.cur
// module id = 450
// module chunks = 0